export default "__VITE_PUBLIC_ASSET__334b7a49__"